import {
  IconArrowsSplit,
  IconAtom,
  IconBackhoe,
  IconBriefcase,
  IconBuildingSkyscraper,
  IconCalendarEvent,
  IconCertificate,
  IconChecklist,
  IconCoin,
  IconDashboard,
  IconHeartHandshake,
  IconHierarchy,
  IconLicense,
  IconPackage,
  IconReceiptDollar,
  IconRecycle,
  IconReportSearch,
  IconTarget,
  IconTool,
  IconTruck,
  IconUser,
  IconUserPlus,
  IconUserX,
  IconWorld,
} from '@tabler/icons-react';
import { Permission } from '../models/core/departments.type';

const LocalStorageKey = {
  ApplicationAccessToken: '@performa:ApplicationAccessToken',
  ApplicationVersion: '@performa:ApplicationVersion',
  User: '@performa:User',
  UserCredentials: '@performa:UserCredentials',
  UserAccessToken: '@performa:UserAccessToken',
  CoreDataReference: '@performa:CoreDataReference',
  BrasilAPIBanks: '@brasilAPI:banks',
  BrasilAPIStates: '@brasilAPI:states',
};

const SessionStorageKey = {
  DashboardGeneral: '@performa:DashboardGeneral',
  DashboardManagerial: '@performa:DashboardManagerial',

  DepartmentSearch: '@performa:DepartmentSearch',
  DismissalSearch: '@performa:DismissalSearch',
  InvitationSearch: '@performa:InvitationSearch',
  UserSearch: '@performa:UserSearch',

  ResidueSearch: '@performa:ResidueSearch',
  ServiceSearch: '@performa:ServiceSearch',
  PackagingSearch: '@performa:PackagingSearch',
  DestinationSearch: '@performa:DestinationSearch',
  EquipmentSearch: '@performa:EquipmentSearch',
  TreatmentSearch: '@performa:TreatmentSearch',
  VehicleSearch: '@performa:VehicleSearch',
  EntitySearch: '@performa:EntitySearch',

  ProposalSearch: '@performa:ProposalSearch',
  ContractSearch: '@performa:ContractSearch',
  EventSearch: '@performa:EventSearch',

  ProposalResidueList: '@performa:ProposalResidueList',
  ProposalServiceList: '@performa:ProposalServiceList',

  ContractStatus: '@performa:ContractStatus',

  TempEntity: '@performa:TempEntity',
  TempEvent: '@performa:TempEvent',
  TempProposal: '@performa:TempProposal',

  BrasilAPICities: '@brasilAPI:cities_{stateCode}',
};

const Feature = {
  Reference: {
    Entity: {
      icon: IconBuildingSkyscraper,
      color: 'indigo',
      label: 'Entidades',
      link: '/entities',
      hasAddLink: true,
      subItems: [],
      permissions: {
        Add: Permission.EntityAdd,
        Delete: Permission.EntityDelete,
        Edit: Permission.EntityEdit,
        Search: Permission.EntitySearch,
        View: Permission.EntityView,
      },
    },
    Residue: {
      icon: IconAtom,
      color: 'green',
      label: 'Resíduos',
      link: '/residues',
      hasAddLink: true,
      subItems: [],
      permissions: {
        Add: Permission.ResidueAdd,
        Delete: Permission.ResidueDelete,
        Edit: Permission.ResidueEdit,
        Search: Permission.ResidueSearch,
        View: Permission.ResidueView,
      },
    },
    Service: {
      icon: IconTool,
      color: 'violet',
      label: 'Serviços',
      link: '/services',
      hasAddLink: true,
      subItems: [],
      permissions: {
        Add: Permission.ServiceAdd,
        Delete: Permission.ServiceDelete,
        Edit: Permission.ServiceEdit,
        Search: Permission.ServiceSearch,
        View: Permission.ServiceView,
      },
    },
    Packaging: {
      icon: IconPackage,
      color: 'cyan',
      label: 'Acondicionamentos',
      link: '/packaging',
      hasAddLink: true,
      subItems: [],
      permissions: {
        Add: Permission.PackagingAdd,
        Delete: Permission.PackagingDelete,
        Edit: Permission.PackagingEdit,
        Search: Permission.PackagingSearch,
        View: Permission.PackagingView,
      },
    },
    Destination: {
      icon: IconTarget,
      color: 'pink',
      label: 'Destinos Finais',
      link: '/destinations',
      hasAddLink: true,
      subItems: [],
      permissions: {
        Add: Permission.DestinationAdd,
        Delete: Permission.DestinationDelete,
        Edit: Permission.DestinationEdit,
        Search: Permission.DestinationSearch,
        View: Permission.DestinationView,
      },
    },
    Equipment: {
      icon: IconBackhoe,
      color: 'grape',
      label: 'Equipamentos',
      link: '/equipment',
      hasAddLink: true,
      subItems: [],
      permissions: {
        Add: Permission.EquipmentAdd,
        Delete: Permission.EquipmentDelete,
        Edit: Permission.EquipmentEdit,
        Search: Permission.EquipmentSearch,
        View: Permission.EquipmentView,
      },
    },
    Treatment: {
      icon: IconRecycle,
      color: 'yellow',
      label: 'Tratamentos',
      link: '/treatments',
      hasAddLink: true,
      subItems: [],
      permissions: {
        Add: Permission.TreatmentAdd,
        Delete: Permission.TreatmentDelete,
        Edit: Permission.TreatmentEdit,
        Search: Permission.TreatmentSearch,
        View: Permission.TreatmentView,
      },
    },
    Vehicle: {
      icon: IconTruck,
      color: 'lime',
      label: 'Veículos',
      link: '/vehicles',
      hasAddLink: true,
      subItems: [],
      permissions: {
        Add: Permission.VehicleAdd,
        Delete: Permission.VehicleDelete,
        Edit: Permission.VehicleEdit,
        Search: Permission.VehicleSearch,
        View: Permission.VehicleView,
      },
    },
  },
  Managerial: {
    Department: {
      icon: IconHierarchy,
      color: 'orange',
      label: 'Departamentos',
      link: '/departments',
      hasAddLink: true,
      subItems: [],
      permissions: undefined,
    },
    User: {
      icon: IconUser,
      color: 'indigo',
      label: 'Usuários',
      link: '/users',
      hasAddLink: false,
      subItems: [],
      permissions: undefined,
    },
    Invitation: {
      icon: IconUserPlus,
      color: 'green',
      label: 'Convites',
      link: '/invitations',
      hasAddLink: true,
      subItems: [],
      permissions: undefined,
    },
    Dismissals: {
      icon: IconUserX,
      color: 'red',
      label: 'Desligamentos',
      link: '/dismissals',
      hasAddLink: false,
      subItems: [],
      permissions: undefined,
    },
  },
  Home: {
    Dashboard: {
      icon: IconDashboard,
      color: 'blue',
      label: 'Dashboards',
      link: '/',
      hasAddLink: false,
      subItems: [
        { icon: IconWorld, label: 'Geral', link: '/', hasAddLink: false, restricted: false },
        {
          icon: IconBriefcase,
          label: 'Gerencial',
          link: '/dashboards/managerial',
          hasAddLink: false,
          restricted: true,
        },
      ],
      permissions: undefined,
    },
    Proposal: {
      icon: IconReportSearch,
      color: 'indigo',
      label: 'Propostas',
      link: '/proposals',
      hasAddLink: true,
      subItems: [],
      permissions: {
        Add: Permission.ProposalAdd,
        Delete: Permission.ProposalDelete,
        Edit: Permission.ProposalEdit,
        Search: Permission.ProposalSearch,
        View: Permission.ProposalView,
        Print: Permission.ProposalPrint,
        Own: Permission.ProposalOwn,
      },
    },
    Contract: {
      icon: IconLicense,
      color: 'green',
      label: 'Contratos',
      link: '/contracts',
      hasAddLink: false,
      subItems: [],
      permissions: {
        Add: Permission.ContractAdd,
        Delete: Permission.ContractDelete,
        Edit: Permission.ContractEdit,
        Search: Permission.ContractSearch,
        View: Permission.ContractView,
        Cancel: Permission.ContractCancel,
      },
    },
    Event: {
      icon: IconCalendarEvent,
      color: 'violet',
      label: 'Eventos',
      link: '/events',
      hasAddLink: false,
      subItems: [
        { label: 'Todos', link: '/events', hasAddLink: false, restricted: false },
        {
          icon: IconHeartHandshake,
          label: 'Comercial',
          link: '/events?filter=commercial',
          hasAddLink: false,
          restricted: false,
        },
        {
          icon: IconCoin,
          label: 'Financeiro',
          link: '/events?filter=financial',
          hasAddLink: false,
          restricted: false,
        },
        {
          icon: IconChecklist,
          label: 'Operacional',
          link: '/events?filter=operational',
          hasAddLink: false,
          restricted: false,
        },
      ],
      permissions: {
        Add: Permission.EventAdd,
        Delete: Permission.EventDelete,
        Edit: Permission.EventEdit,
        Search: Permission.EventSearch,
        View: Permission.EventView,
        Print: Permission.EventPrint,
      },
    },
    Integration: {
      icon: IconArrowsSplit,
      color: 'orange',
      label: 'Integrações',
      link: '/integrations',
      hasAddLink: false,
      subItems: [
        {
          icon: IconCertificate,
          label: 'MTR',
          link: '/integrations/mtrs',
          hasAddLink: false,
          restricted: false,
        },
        {
          icon: IconReceiptDollar,
          label: 'NFe',
          link: '/integrations/nfes',
          hasAddLink: false,
          restricted: false,
        },
      ],
      permissions: {
        Add: Permission.Integration,
        Delete: Permission.Integration,
        Edit: Permission.Integration,
        Search: Permission.Integration,
        View: Permission.Integration,
        Print: Permission.Integration,
        Own: Permission.Integration,
      },
    },
  },
};

const Chart = {
  Color: {
    'Receita (Potencial)': '#B2F2BB',
    Receita: '#51CF66',
    'Despesa (Potencial)': '#FFC9C9',
    Despesa: '#FF6B6B',
    'Imposto (Potencial)': '#FFD8A8',
    Imposto: '#FF922B',
    'Balanço (Potencial)': '#BAC8FF',
    Balanço: '#5C7CFA',

    'Tonelada(s) (Potencial)': '#D0BFFF',
    'Tonelada(s)': '#845EF7',
    'Metro(s) Cúbico(s) (Potencial)': '#96F2D7',
    'Metro(s) Cúbico(s)': '#20C997',

    'Acondicionamento (Potencial)': '#99E9F2',
    Acondicionamento: '#22B8CF',
    'Equipamento (Potencial)': '#EEBEFA',
    Equipamento: '#CC5DE8',
    'Veículo (Potencial)': '#D8F5A2',
    Veículo: '#94D82D',
  },
};

const Core = {
  SystemId: '00000000-0000-0000-0000-000000000000',
};

export enum EntityItemEnum {
  Packaging = 'Acondicionamento',
  Destination = 'Destino Final',
  Equipment = 'Equipamento',
  Service = 'Serviço',
  Treatment = 'Tratamento',
  Vehicle = 'Veículo',
}

const RecurrenceData = {
  Days: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
  Months: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  Frequency: [
    { label: 'dia(s)', value: 'd' },
    { label: 'semana(s)', value: 'w' },
    { label: 'mês(es)', value: 'm' },
    { label: 'ano(s)', value: 'y' },
  ],
};

const Financial = {
  Margin: 40,
  Tax: 14.25,
};

export { Chart, Core, Feature, Financial, LocalStorageKey, RecurrenceData, SessionStorageKey };
